export default __webpack_public_path__ + "static/media/LOGO.41a85800.webp";